import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from '@angular/core';
import { Page, Component as BrComponent } from '@bloomreach/spa-sdk';
import { HighchartsThemeService } from '@frk/eds-components';
import { BaseProductDetailComponent } from '@products/base-product-detail.component';
import { ProductDetailConfiguration, LiquidityState } from '@types';
import { Logger } from '@utils/logger';
import { Subscription } from 'rxjs';
import { PricingDistributionDisplayComponent } from '../pricing-distribution-component.interface';
import { PricingDistributionConfig } from '../pricing-distribution.config';
import { LiquidityService } from '../services/liquidity.service';

const logger = Logger.getLogger('LiquidAssetsComponent');

@Component({
  selector: 'ft-liquid-assets',
  templateUrl: './liquid-assets.component.html',
  styleUrls: ['./liquid-assets.component.scss'],
  providers: [LiquidityService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiquidAssetsComponent
  extends BaseProductDetailComponent
  implements PricingDistributionDisplayComponent, OnDestroy {
  componentConfiguration: PricingDistributionConfig;
  dataSubscription: Subscription;
  highcharts;
  chartOptions: Highcharts.Options = {};
  loadChart = false;
  chartAsOfDate: string;

  constructor(
    private liquidityService: LiquidityService,
    private changeDetector: ChangeDetectorRef,
    private highchartsTheme: HighchartsThemeService
  ) {
    super();
  }

  populate(
    componentConfig: PricingDistributionConfig,
    brConfig: ProductDetailConfiguration,
    component: BrComponent,
    page: Page
  ): void {
    this.initialize(brConfig, component, page);
    logger.debug(page, this.page);
    this.componentConfiguration = componentConfig;
    this.changeDetector.detectChanges();
    if (this.brConfig.fundId) {
      this.liquidityService.setConfigurationName(
        componentConfig.configurationName
      );
      this.dataSubscription = this.liquidityService.liquidityState.subscribe(
        (state) => this.mapState(state)
      );
      this.liquidityService.populate(brConfig);
    }
  }

  /**
   * Called when state changes.
   * @param liquidityState the state returned by liquid assets service
   */
  mapState(liquidityState: LiquidityState): void {
    import(/* webpackChunkName: "highcharts-async" */ 'highcharts').then(
      (highchartsModule) => {
        highchartsModule.setOptions(this.highchartsTheme.themeOptions);
        this.highcharts = highchartsModule;
      }
    );

    this.chartOptions = liquidityState.chartConfig.highChartOptions;
    this.loadChart = liquidityState.hasLoadedFullFeed;
    this.chartAsOfDate = liquidityState.asOfDate;

    this.changeDetector.detectChanges();
  }

  ngOnDestroy(): void {
    // clean up subscription to avoid memory leaks
    this.dataSubscription?.unsubscribe();
  }
}
